import { render, staticRenderFns } from "./ChildrensResources.vue?vue&type=template&id=7aee5263&"
import script from "./ChildrensResources.vue?vue&type=script&lang=js&"
export * from "./ChildrensResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports